import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "preview", "placeholder", "dropZone", "filename", "submitBtn"]

    connect() {
        this.inputTarget.addEventListener('click', (e) => e.stopPropagation());

        this.boundPreventDefaults = this.preventDefaults.bind(this);

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            this.dropZoneTarget.addEventListener(eventName, this.boundPreventDefaults, false);
        });

        ['dragenter', 'dragover'].forEach(eventName => {
            this.dropZoneTarget.addEventListener(eventName, () => this.highlight(), false);
        });

        ['dragleave', 'drop'].forEach(eventName => {
            this.dropZoneTarget.addEventListener(eventName, () => this.unhighlight(), false);
        });

        this.dropZoneTarget.addEventListener('drop', (e) => this.handleDrop(e), false);
    }

    disableSubmit(e) {
        // Only disable if we actually have a file selected
        if (this.inputTarget.files.length > 0) {
            const btn = this.submitBtnTarget
            btn.disabled = true
            btn.classList.add("opacity-75", "cursor-wait")
            // Swap text to show processing state
            btn.innerHTML = `
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Uploading...
            `
        }
    }

    preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    highlight() {
        this.dropZoneTarget.classList.add("border-primary", "bg-primary/5");
        this.dropZoneTarget.classList.remove("border-slate-300", "dark:border-slate-700");
    }

    unhighlight() {
        this.dropZoneTarget.classList.remove("border-primary", "bg-primary/5");
        this.dropZoneTarget.classList.add("border-slate-300", "dark:border-slate-700");
    }

    trigger(event) {
        event.preventDefault(); // Stop the immediate click on the div
        this.inputTarget.click(); // Open the dialog
    }

    handleDrop(e) {
        const dt = e.dataTransfer;
        const files = dt.files;
        this.handleFiles(files);
    }

    handleSelect(e) {
        const files = this.inputTarget.files;
        this.handleFiles(files);
    }

    handleFiles(files) {
        if (files.length > 0) {
            const file = files[0];
            this.filenameTarget.textContent = file.name;
            this.previewFile(file);

            // Sync files to input for form submission
            // (Required because drag-drop doesn't automatically set the file input value)
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            this.inputTarget.files = dataTransfer.files;
        }
    }

    previewFile(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.placeholderTarget.classList.add("hidden");
            this.previewTarget.src = reader.result;
            this.previewTarget.classList.remove("hidden");
        }
    }
}